import {
    createStore
} from 'redux';
import { loadState, saveState } from '../localStorage';
import { UrlState } from './urlState';
import initialState from './initialState';
import rootReducer from '../reducers';

const wizardDataElem = document.querySelector('[data-wizard]');
const wizardJSON = JSON.parse(wizardDataElem.getAttribute('data-wizard'));
const urlState = new UrlState(Object.assign(initialState, wizardJSON));

let persistedState = null;
if (urlState.enabled) {
    persistedState  = urlState.alterState();
} else {
    persistedState  = loadState(Object.assign(initialState, wizardJSON));
}

const store = createStore(rootReducer, persistedState);

export default class Store {
    constructor() {
        store.subscribe(() => {
            saveState(store.getState());
        });
    }

    static getStore() {
        return store;
    }

    static getState() {
        return store.getState();
    }
}
